var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-data-table"},[_c('a-table',{attrs:{"columns":_vm.normalizedColumns,"data-source":_vm.items,"row-key":_vm.rowKey,"row-selection":_vm.rowSelection,"pagination":_vm.paginationConfig,"loading":_vm.loading,"scroll":_vm.scroll},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }